//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select } from "redux-saga/effects";
import { types as sitetreeTypes } from "../SiteTree/redux";
import { TreeFlatener, TreeMap, DateTime, AsyncSaga, seriesColor } from "../../utils";
import { types as reportTypes } from "../../ui/Rules/Reports/redux";

const initialState = {
      colorDictionary: [],
      colorIndex: 0,
};

/////////
//types
export const types = {
      NEW_POINT: "services/SeriesColor/NEW_POINT",
      UPDATE_COLOR_DICTIONARY: "services/SeriesColor/UPDATE_COLOR_DICTIONARY",
      RESET_DICTIONARY: "services/SeriesColor/RESET_DICTIONARY",
};

///////////
//reducers
export const reducers = {
   reducer(state = initialState, action) {
      switch (action.type) {	
            case types.UPDATE_COLOR_DICTIONARY:
                  return { ...state, colorDictionary: action.payload.colorDictionary, colorIndex: action.payload.index };
            case types.RESET_DICTIONARY:
                  return { ...state, colorDictionary: [], colorIndex: 0 }
            default:
                  return state;
      }
   }
};

//////////
//sagas
export const sagas = {
      *rootSaga() {
            yield all([
                  this.onNewPoint(),
                  this.onGetReport(),
            ]);
      },
      *onGetReport() {
            yield takeEvery(reportTypes.GET_REPORT, function*() {
                  yield put(actions.resetDictionary());
            });
      },
      *onNewPoint() {
            yield takeEvery(types.NEW_POINT, function*({payload}) {
                  let {colorDictionary, colorIndex} = yield select(x => x.seriesColor);

                  colorDictionary[payload.pointName] = payload.colorCode;

                  var newIndex = colorIndex + 1;
                  if(newIndex >= seriesColor.getSeriesColors().length) {
                        newIndex = 0;
                  }

                  yield put(actions.updateColorDictionary(colorDictionary, newIndex));
            });
      }
};

////////
//actions
export const actions = {
      newPoint(pointName, colorCode) {
            return {
                  type: types.NEW_POINT,
                  payload: {pointName, colorCode}
            }
      },
      updateColorDictionary(colorDictionary, index) {
            return {
                  type: types.UPDATE_COLOR_DICTIONARY,
                  payload: {colorDictionary, index}
            }
      },
      resetDictionary() {
            return {
                  type: types.RESET_DICTIONARY
            }
      }
};



// WEBPACK FOOTER //
// ./src/services/SeriesColor/redux.js